export const msalConfig = {
  auth: {
    clientId: 'f3ad2154-7e10-4730-a055-8852ced42d47',
    authority: "https://login.microsoftonline.com/common",
    redirectUri: "https://demo.heedify.io/"
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  }
};
export const loginRequest = {
  scopes: ["User.Read"],
};
export const HEEDIFY_PROVIONONG_PATH_V2 = "https://provisioning.heedify.io/api/V2";
export const ANALYTICS_API_BASE = "https://analytics.heedify.io/api";
export const GRAPH_BASE_URL = "https://graph.microsoft.com/v1.0";
export const TEXT_TO_SPEECH = "https://func-tts-qa-ne-01.azurewebsites.net/api/text2Speech";
export const SIGNALR_PATH = "https://signal.heedify.io/api";
